"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HasMapStore = void 0;
const mobx_1 = require("mobx");
class HasMapStore {
    constructor(creater) {
        this.creater = creater;
        this.map = new Map();
        mobx_1.makeObservable(this);
    }
    get(key) {
        if (!this.map.has(key)) {
            const query = this.creater(key);
            mobx_1.runInAction(() => {
                this.map.set(key, query);
            });
        }
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this.map.get(key);
    }
    has(key) {
        return this.map.has(key);
    }
}
__decorate([
    mobx_1.observable.shallow
], HasMapStore.prototype, "map", void 0);
exports.HasMapStore = HasMapStore;
//# sourceMappingURL=index.js.map